<template>
  <div class="signinView">
    <header-comp :isSigninView="true"/>
    <div class="">
      <signin-comp/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'signinView',
  components: {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>

.signinView{
  width: 100vw;
  height: 100vh;
  display: grid;
  grid-template-rows: 90px 1fr;
  grid-template-columns: 1fr;
  margin: 0;
}
.signinView > div > div{
  margin: 112px auto auto auto;
}

@media screen and (max-width: 720px){
  .signinView > div > div{
    margin: 32px auto auto auto;
  }
}
@media screen and (max-width: 320px){
  .signinView > div > div{
    grid-template-rows: 70px 1fr;
  }
}
</style>
